<script>
	import { PlayIcon } from 'lucide-svelte';
</script>

<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="relative row-span-3 flex h-full w-full flex-row items-center justify-center">
			<div
				class="border-darkQuaternary bg-darkSecondary group-hover:bg-darkTertiary absolute z-20 mx-auto flex h-16 w-16 items-center justify-center overflow-hidden rounded-lg border transition-all duration-300 group-hover:h-32 group-hover:w-52"
			>
				<PlayIcon
					class="transition-color text-lightTertiary group-hover:text-lightQuaternary h-5 w-5"
				/>
			</div>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/rank/platinum.png"
				class="border-darkQuaternary bg-darkSecondary absolute bottom-4 right-10 h-10 w-10 rounded-full border p-2 transition-all duration-300 group-hover:bottom-10 group-hover:right-32 group-hover:h-0 group-hover:w-0"
				alt="vods-1"
			/>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/stat-mods/StatModsArmorIcon.png"
				class="border-darkQuaternary bg-darkSecondary absolute right-16 top-0 h-7 w-7 rounded-full border p-1 transition-all duration-300 group-hover:right-32 group-hover:top-10 group-hover:h-0 group-hover:w-0"
				alt="vods-2"
			/><enhanced:img
				loading="lazy"
				src="/static/images/lol/lanes/top.svg"
				class="border-darkQuaternary bg-darkSecondary absolute bottom-4 left-16 h-6 w-6 rounded-full border p-1 transition-all duration-300 group-hover:bottom-10 group-hover:left-32 group-hover:h-0 group-hover:w-0"
				alt="vods-3"
			/>
			<enhanced:img
				loading="lazy"
				src="/static/images/lol/rank/grandmaster.png"
				class="border-darkQuaternary bg-darkSecondary absolute left-12 top-2 h-9 w-9 rounded-full border p-1.5 transition-all duration-300 group-hover:left-32 group-hover:top-10 group-hover:h-0 group-hover:w-0"
				alt="vods-4"
			/>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">VODs</h3>
			<p class="text-lightTertiary">
				Learn from the best thanks to our friends at <a
					class="text-lightTertiary transition-colors hover:text-purple-500"
					href="https://mid.gg">mid.gg</a
				>!
			</p>
		</div>
	</div>
</div>
